// The colors in this list represent line colors in our trends charts.
export const VISUALIZATION_COLORS = [
  'blue-40',
  'pink-50',
  'green-50',
  'purple-60',
  'yellow-30',
] as const;

export const VISUALIZATION_COLORS_NEW = [
  'violet-60',
  'visualization-1',
  'visualization-2',
  'visualization-3',
  'visualization-4',
] as const;

// This color is used for the lines/segment legend in our dimensionality chart.
export const DIMENSIONALITY_COLOR = 'blue-50' as const;

// The colors in this list represent line colors in our retention charts.
export const RETENTION_VISUALIZATION_COLORS = [
  ...VISUALIZATION_COLORS,
  'green-30',
  'yellow-50',
  'purple-40',
  'blue-70',
  'red-70',
] as const;

// Number of top pages to show in the Page Flow visualization
export const PAGE_FLOW_TOP_PAGES_COUNT = 5;

export const getVisualizationColors = (enableNewColors: boolean = false) =>
  enableNewColors ? VISUALIZATION_COLORS_NEW : VISUALIZATION_COLORS;
